import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../../core/auth/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.html',
  imports: [RouterLink, RouterLinkActive],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  private authService = inject(AuthService);

  protected userInfo = this.authService.userInfo;
  protected isAdmin = this.authService.isAdmin;
  protected dropdownOpen = signal(false);

  protected toggleDropdown(): void {
    this.dropdownOpen.update(v => !v);
  }

  protected async logout(): Promise<void> {
    this.dropdownOpen.set(false);
    await this.authService.signOut();
  }
}
